import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormGroup, Radio} from "react-bootstrap";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import moment from "moment";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";

class RaportZapelnieniaSearchbox extends Component {

    state = {
        dataOd: moment(),
        dataDo: moment(),
        trasa: null,
        linia: null,
        czyTrasa: true
    }

    formatTrasaSelect = (option) => {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                        wartosc={option.status}
                                                                                                                        czyMarginesLewy={true}/>
        </div>
    };

    formatLiniaSelect = (option) => {
        return (<div>
            <span className={'label label-ebus-primary'}>{option.idLi}</span> {option.relacja}
        </div>)
    }

    onChangeData = (e, key) => {
        this.setState({[key]: e})
    };


    onClickSzukaj = () => {
        if (Boolean(this.state.dataOd) && Boolean(this.state.dataDo) && (Boolean(this.state.trasa) || Boolean(this.state.linia))) {
            if (this.state.dataOd <= this.state.dataDo) {
                this.props.handleClickSzukaj({
                    dataOd: DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                    dataDo: DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),

                    idTr: (this.state.trasa) ? this.state.trasa.idTr : '',
                    nazTr: (this.state.trasa) ? this.state.trasa.nazTr : '',

                    idLi: (this.state.linia) ? this.state.linia.idLi : '',
                    nazLi: (this.state.linia) ? this.state.linia.relacja : '',
                })
            } else {
                alert("Data od nie może być większa niż data do")
            }
        } else {
            alert('Nie uzupełniono wszytskich pól!')
        }

    };

    render() {
        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={2}>
                            <ControlLabel>Data od <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate onChange={(e) => this.onChangeData(e, 'dataOd')} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Data do <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate onChange={(e) => this.onChangeData(e, 'dataDo')} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={3}>
                            <div>
                            <Radio inline={true} checked={this.state.czyTrasa} onChange={() => this.setState({czyTrasa: true})}>
                                <span style={{fontWeight:'bold'}}>Trasa</span><span className={'req'}>*</span>
                            </Radio>
                            <span style={{fontWeight:'normal',margin:'0 5px'}}>bądź</span>
                            <Radio inline={true} checked={!this.state.czyTrasa} onChange={() => this.setState({czyTrasa: false})}>
                                <span style={{fontWeight:'bold'}}>Linia</span><span className={'req'}>*</span>
                            </Radio>
                            </div>
                            {
                                this.state.czyTrasa ?

                                    <TopSelect onChange={(e) => this.setState({trasa: e, linia: null})}
                                               value={this.state.trasa}
                                               options={this.props.trasy}
                                               labelKey={'nazTr'}
                                               valueKey={'idTr'}
                                               valueRenderer={this.formatTrasaSelect}
                                               optionRenderer={this.formatTrasaSelect}
                                               placeholder={'Wybierz trasę'}
                                    />
                                    :


                                    <TopSelect onChange={(e) => this.setState({trasa: null, linia: e})}
                                               value={this.state.linia}
                                               options={this.props.linie}
                                               labelKey={'relacja'}
                                               valueKey={'idLi'}
                                               valueRenderer={this.formatLiniaSelect}
                                               optionRenderer={this.formatLiniaSelect}
                                               placeholder={'Wybierz linie'}
                                    />
                            }
                        </Col>
                        <Col xs={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction onClick={this.onClickSzukaj} text={'Szukaj'} btnColor={'primary'} iconType={'fa fa-search'}
                                             btnSize={'md'}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default RaportZapelnieniaSearchbox;


// WEBPACK FOOTER //
// ./src/modules/raporty/RaportZapelnienia/components/RaportZapelnieniaSearchbox.js